import { render } from "./criteria-question-panel.vue?vue&type=template&id=5f6bba9c&scoped=true&ts=true"
import script from "./criteria-question-panel.vue?vue&type=script&lang=ts"
export * from "./criteria-question-panel.vue?vue&type=script&lang=ts"

import "./criteria-question-panel.vue?vue&type=style&index=0&id=5f6bba9c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f6bba9c"]])

export default __exports__